const DEFAULT = null;

export default state => state.canvas.usage || DEFAULT;
